import React, { useCallback } from 'react';
import {useSelector, useDispatch} from 'react-redux';

import { IconButton } from '@mui/material';
import {withRouter} from 'react-router-dom';

import CloseIcon from '@mui/icons-material/Close';

import * as actions from '../../../store/actions';
import Spinner from '../../../components/Spinner/index';

import {
  FormStyled,
  DivSubmitButtons,
} from '../Forms/styles';

import MassiveImport from './../MassiveImport';

const ModalMassiveImport = (props) => {
  const dispatch = useDispatch();

  const loading = useSelector(state => state.equipmentServices.loading);
  
  const fetchEquipmentModels = useCallback(
    () => dispatch(actions.fetchEquipmentModelById(props.equipmentModelId))
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    fetchEquipmentModels();
    props.closeModal();
  };

  return <>
    <FormStyled onSubmit={handleSubmit}>
      {loading && <Spinner overlay />}
      <DivSubmitButtons>
          <IconButton type="submit" size="large">
            <CloseIcon fontSize="large" />
          </IconButton>
        </DivSubmitButtons>
    </FormStyled>
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        margin: '10px 0',
      }}
    >
      <MassiveImport
        type="checklist"
        equipmentServiceId={props.equipmentServiceId}
      />      
    </div>
  </>;
};

export default withRouter(ModalMassiveImport);
